import React, { useState } from 'react';
import { 
  FaHome, 
  FaUsers, 
  FaCheckCircle,
  FaClock,
  FaTimesCircle,
  FaEdit
} from 'react-icons/fa';
import EditarDestaquesModal from '../../components/EditarDestaquesModal';

const OverviewTab = ({ stats, recent, formatCurrency, onEditDestaques }) => {
  const isAuthenticated = localStorage.getItem('token');
  const [showEditModal, setShowEditModal] = useState(false);

  if (!stats) return null;

  return (
    <>
      {isAuthenticated && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
          <button 
            className="btn-add" 
            onClick={() => setShowEditModal(true)}
            style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
          >
            <FaEdit /> Editar Oportunidade de Hoje
          </button>
        </div>
      )}

      {/* Cards de Estatísticas */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#667eea' }}>
            <FaHome />
          </div>
          <div className="stat-content">
            <h3>{stats.totalImoveis}</h3>
            <p>Total de Imóveis</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#27ae60' }}>
            <FaHome />
          </div>
          <div className="stat-content">
            <h3>{stats.imoveisDisponiveis}</h3>
            <p>Imóveis Disponíveis</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#e74c3c' }}>
            <FaUsers />
          </div>
          <div className="stat-content">
            <h3>{stats.totalClientes}</h3>
            <p>Total de Clientes</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#27ae60' }}>
            <FaCheckCircle />
          </div>
          <div className="stat-content">
            <h3>{stats.agendamentosRealizados || 0}</h3>
            <p>Agendamentos Realizados</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#f39c12' }}>
            <FaClock />
          </div>
          <div className="stat-content">
            <h3>{stats.agendamentosPendentes || 0}</h3>
            <p>Agendamentos Pendentes</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon" style={{ background: '#e74c3c' }}>
            <FaTimesCircle />
          </div>
          <div className="stat-content">
            <h3>{stats.agendamentosCancelados || 0}</h3>
            <p>Agendamentos Cancelados</p>
          </div>
        </div>
      </div>

      {/* Atividades Recentes */}
      <div className="dashboard-sections">
        <div className="dashboard-section">
          <h2>Imóveis Recentes</h2>
          <div className="recent-list">
            {recent?.imoveis && recent.imoveis.length > 0 ? (
              recent.imoveis.map(imovel => {
                const dataCriacao = imovel.createdAt || imovel.created_at;
                const dataFormatada = dataCriacao && !isNaN(new Date(dataCriacao).getTime())
                  ? new Date(dataCriacao).toLocaleString('pt-BR', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  : '-';
                
                return (
                  <div key={imovel.id} className="recent-item">
                    <div className="recent-item-icon">
                      <FaHome />
                    </div>
                    <div className="recent-item-content">
                      <h4>{imovel.tipo} - {imovel.bairro}</h4>
                      <p>Cód: {imovel.codigo}</p>
                      <span className="imovel-price">
                        {imovel.operacao === 'locacao' 
                          ? `${formatCurrency(imovel.preco)} / mês`
                          : formatCurrency(imovel.preco)
                        }
                      </span>
                    </div>
                    <div className="recent-item-date">
                      {dataFormatada}
                    </div>
                  </div>
                );
              })
            ) : (
              <p>Nenhum imóvel recente</p>
            )}
          </div>
        </div>
      </div>

      <EditarDestaquesModal
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSave={() => {
          if (onEditDestaques) {
            onEditDestaques();
          }
        }}
      />
    </>
  );
};

export default OverviewTab;


